module.exports = __webpack_public_path__ + "media/images/tl/banner/th-2-dark-8affe683e2d404e0926211d1f3ad66b9.jpg";